import {GatewayType} from "../gateway-type/GatewayType";
import {DeviceAlarmStatusEnum} from "../notification/DeviceAlarmStatus";
import {ChangeTypeEnum} from "../../ope/gateway-pending-config/GatewayPendingConfigPayloadDTO";

export class Gateway {
  id!: number;
  name!: string;
  partitionId?: number;
  type?: GatewayType;
  macAddress?: string;
  online!: boolean;
  status!: string;
  updateWorkflowStatusTs?: string;
  sendingCron?: string;
  netConfig?: string;
  devices?: DeviceLite[];
  hasPendingDevice?: boolean;
  hasPendingGatewayFields?: boolean;
  changeType?: ChangeTypeEnum;

  constructor() {
    this.sendingCron = "M1";
  }
}

export class DeviceLite {
  id!: number;
  name!: string;
  alarmStatus?: DeviceAlarmStatusEnum;
  partitionId?: number;
  gatewayId?: number;
  type!: DeviceTypeLite;

  rtuTransportConfiguration?: RTUTransportConfiguration;
  tcpTransportConfiguration?: TCPTransportConfiguration;

  acquisitionCron?: string;

  // Only populated when the device list is sourced from a real draft (see
  // GatewayDeviceComponent.refreshGatewayDeviceList) - undefined for an official/no-draft tree.
  changeType?: ChangeTypeEnum;
}

class DeviceTypeLite {
  id!: number;
  modelName!: string;
  protocolType!: string;
  label?: string | null;
}

class RTUTransportConfiguration {
  deviceAddr!: number;
  portName!: string;
  timeout!: number;
  baudRate!: number;
  dataBits!: number;
  stopBits!: number;
  parity!: string;
}

class TCPTransportConfiguration {
  ipAddress!: string;
  port!: number;
  timeout!: number;
}
